import React from "react";
import ReactDOM from "react-dom/client";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import ErrorBoundary from "./components/RouteErrorBoundary ";

import App from "./App";
import MyProvider from "./MyContextApi";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <AuthProvider>
      <MyProvider>
        {/* <React.StrictMode> */}
        <App />
        {/* </React.StrictMode> */}
      </MyProvider>
    </AuthProvider>
  </ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
